const useIsMobileDevice = () => {
  return {
    isMobile: globalThis.gazeta_pl.device !== 'NOT_MOBILE',
  };
};

export default useIsMobileDevice;
